import {getCatalogBtn} from "./helper/helpers";
import {CatalogContext} from "./catalog_context";
import useToggleCart from "./hooks/useToggleCart";
const isLoadingText = gettext('Loading...');

const FreeButton = (props) => {
    const {isLoading, formAttr, toggleCart, removeFromAcct} = useToggleCart(props.product, props)
    const productButton = getCatalogBtn();
    const ctxCatalog = React.useContext(CatalogContext);
    const { catalog_data } = ctxCatalog;
    const isProductOwned = catalog_data.addons[props.product.key];
    let product = props.product;
    let button;
    if (catalogModule.getSource() === "ITUNES") {
        button = <a href="https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/manageSubscriptions" target="_blank">
            <button className={productButton} disabled={isLoading}>{gettext("Manage")}</button>
        </a>;
    } else {
        if(catalog_data.app_theme === "manager"){
            if(isProductOwned && props.product.type === "free"){
                button = <React.Fragment>
                    <button onClick={removeFromAcct} className={formAttr.btn} disabled={isLoading}>
                        {isLoading && <div className="spinner-border spinner-border-sm mr-1" role="status">
                            <span className="visually-hidden">{isLoadingText}</span>
                        </div>}
                        {isLoading && isLoadingText}
                        {!isLoading && formAttr.text}
                    </button>
                </React.Fragment>
            } else {
                button = <React.Fragment>
                    <button onClick={toggleCart} className={formAttr.btn} disabled={isLoading}>
                        {isLoading && <div className="spinner-border spinner-border-sm mr-1" role="status">
                            <span className="visually-hidden">{isLoadingText}</span>
                        </div>}
                        {isLoading && isLoadingText}
                        {!isLoading && formAttr.text}
                    </button>
                </React.Fragment>
            }
        } else {
            button = <button className={productButton}
                             onClick={() => freeSubscription(product.key, this)}
                             title={gettext("Click here to add this addon for free")}>
                <span className="cart">{gettext("Get for free")}</span></button>;
        }
    }
    return (
        <React.Fragment>
            {button}
        </React.Fragment>
    )
};

export default FreeButton
